// extracted by mini-css-extract-plugin
export default {"label":"label--kx0wLQ237quFKZwbITi5","labelText":"label-text--do2dtA8UFNoHvVv_i0lU","asterix":"asterix--iAHRTGEPYLbOAhYMHJyE"};